module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_021"
    }
  }, [_c('strong', [_vm._v("“THE PLANE”")])])]), _c('a', {
    attrs: {
      "id": "file_021"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Orders for more floats came soon after, both contractor and customer overjoyed with their new contrivance and its improvement of the Corsair’s utility. Then came the question Leroy Grumman had anticipated for weeks, if not months—could the ingenious retractable gear mechanism seen in his floats be modified to work in a fighter plane?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d116b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_021.vue
// module id = 114
// module chunks = 0